import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function PreviousYearQuestionsPhysTopics() {



  return (
    <>

      <PracticsQuestionTopics subject="physics" type="previousyearquestions" />

    </>
  );
}

export default PreviousYearQuestionsPhysTopics;